// extracted by mini-css-extract-plugin
export default {"rootHeader":"styles_rootHeader__eeIpb","buttonsWrapper":"styles_buttonsWrapper__sFDKv"};